// extracted by mini-css-extract-plugin
export default {"banner":"index_banner_5mWqc","href":"index_href_h2-NG"};